import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
      primary: {
      
        main: '#06adaf',
        contrastText: '#fff'
      },
      secondary: {
       
        main: '#ff914d',
       contrastText: '#fff'
      },
      info: {
      
        main: '#fff',
        contrastText: '#06adaf'
      },
    },
  });
  export default theme;